import React from 'react';
import PropTypes from 'prop-types';
import { Autocomplete, createFilterOptions } from "@material-ui/lab";
import { TextField, Chip } from "@material-ui/core";
import { getOptionsType } from './optionTypes';
import { formatName, formatNames, sortArray } from '../../utils';
import removeCircle from '../../svgs/removeCircle.svg';
import arrow from '../../svgs/Arrow.svg';
import close from '../../svgs/X.svg';
import Input from "../Input-new/Input";

require('./Dropdown.scss');

const defaultFilterOptions = (options, state) => {
    const input = (state.inputValue || "").toLowerCase().trim();

    if (!input) return options;

    return options.filter(option => {
        if (!option || typeof option !== 'object') return false;

        const first = typeof option.first_name === 'string' ? option.first_name.toLowerCase().trim() : '';
        const last = typeof option.last_name === 'string' ? option.last_name.toLowerCase().trim() : '';
        const company = typeof option.company_name === 'string' ? option.company_name.toLowerCase().trim() : '';

        // Skip if all are empty
        if (!first && !last && !company) return false;

        const fullName = `${first} ${last}`.trim(); // 👈 Full name match

        return (
            first.includes(input) ||
            last.includes(input) ||
            fullName.includes(input) ||   // ✅ allows "jason kee"
            company.includes(input)
        );
    });
};

const percentDecimals = 2;

const Dropdown = ({ dropdownType = 'single', inputMode = false, options, optionsType, optionKey, optionLabelKey, value, valueKey, percentKey, firmName, label, percentLabel, data, hasAgentPercent, handleParentChange, handleInputParentChange, disabled = false, viewMode = false, groupBy = false, addNewItem, withAddNew, isFilter = false, theme = 'default', placeholder, hasDrawer, isFromProperty = false, deleted = false, typeKey, typeValue, fillText = null, getSelectedOption, className = '', viewClassName = '', id, index, isOffMarket = false, tooltip, tooltipPosition = 'up', handleInputFocus, openOnFocus = false, required, client = {}, customValues = false, vendorData = [], onSearchInput ,newBuyerValue}) => {
    const [searchInput, setSearchInput] = React.useState('');
    React.useEffect(() => {
        if (!viewMode && !searchInput && values) {
            setSearchInput(getOptionLabel(values)); // Set input from selected value
        }
    }, [values, viewMode]);
    let optionList = options ? options : getOptionsType(optionsType, client, vendorData);
React.useEffect(() => {
  if (newBuyerValue) {
    const { first_name, last_name } = newBuyerValue;

    const fullName =
      (first_name && last_name && `${first_name} ${last_name}`) ||
      last_name ||
      first_name;

    if (fullName) {
      setSearchInput(fullName);
    }
  }
}, [newBuyerValue]);
    const getOptionLabel = (option) => {
        if (!option) return ''; // Handle null or undefined options gracefully

        if (option.type === 'div') {
            return option;
        }

        switch (optionsType) {
            case 'firm':
                return option.NAME ? option.NAME : ''; // Use NAME for these types
            case 'lender':
                return option.name ? option.name : ''; // Use NAME for these types
            case 'agent':
                return option ? formatNames(option) : ''
            case 'agent-all':
                return option ? formatNames(option) : ''
            case 'buyer':
            case 'seller':
            case 'invesstor':
                return option ? formatNames(option) : ''
            case 'borrower':

                return option ? formatNames(option) : ''; // Use AGENT_NAME for these types

            case 'team':
                return option ? formatNames(option) : '';

            case 'tenant':
                return option.name ? option.name : '';

            case 'title-company':
                if (typeof option === 'string') {
                    return option.length && option !== 'Other' ? `${option.slice(0, 70)}...` : option;
                }
                return '';

            default:
                if (option === 'UPLOADS') {
                    return 'UPLOAD';
                }

                if (optionLabelKey && option[optionLabelKey] !== undefined) {
                    return String(option[optionLabelKey]); // Use optionLabelKey if specified
                }

                if (optionKey && option[optionKey] !== undefined) {
                    return String(option[optionKey]); // Use optionKey if specified
                }

                return String(option); // Fallback: return option as a string
        }
    };



    const getValuesForDropdown = (data, options, optionKey, type = 'multiple') => { // new code in response[0] the data is not in proper order issue facing in buyers-filter-agent field if selected id is more then 100
        if (!data || !options || !options.length) return [];
        let formattedQueryValues = (typeof data !== 'object' && !Array.isArray(data)) ? data : data.ARCIMEDES_ROW_ID ? data.ARCIMEDES_ROW_ID : data.split(',')
        let response = [];
        const formattedValuesStr = formattedQueryValues.toString(); // Convert to string for comparison

        options.forEach((el) => { //when in the dropdown if we select any of status like hsc-status its taking status in th ui only and its will be same for same name included
            const formattedValues = formattedValuesStr.split(','); // Split once for efficiency
            const elValue = String(el[optionKey] || el); // Determine the key for matching
            const isOptionKeyMatch = formattedValues.includes(elValue); // Match using specified key
            const isSimpleMatch = formattedValues.includes(String(el.code)); // Explicitly match `code`
            const isGroupedMatch = el.groupedBy === typeValue; // Match grouping, if necessary

            // Adjusted conditions for precise matching
            if ((!typeKey && isOptionKeyMatch) || (typeKey && isOptionKeyMatch && isGroupedMatch)) {
                response.push(el);
            }
        });
        const reorderedData = response.sort((a, b) => {
            const aId = a.arcimedes_row_id || a.ARCIMEDES_ROW_ID;
            const bId = b.arcimedes_row_id || b.ARCIMEDES_ROW_ID;
            if (aId === formattedValuesStr) return -1;
            if (bId === formattedValuesStr) return 1;
            return 0;
        });
        if (!response)
            response = [];
        if (type === "single") {
            response = reorderedData[0] ? reorderedData[0] : null;
            if (inputMode) {
                response = data;
            }
        }
        if (getSelectedOption)
            getSelectedOption(response);

        return response;
    };
    const handleChangeDropdown = ({ reason, valueKey, dropdownType = 'single', optionKey = null, alphabetic = false, parentData, isFilter = false }) => {
        const previosData = { ...parentData };
        const data = { ...parentData };

        if (isFromProperty) {
            if (reason && ['LISTING_AGENT_4', 'BUYER_AGENT_4'].includes(valueKey) && reason.FIRM && reason.FIRM !== "0")
                data[valueKey + '_FIRM'] = reason.FIRM;

            if (['LISTING_AGENT_4', 'BUYER_AGENT_4'].includes(valueKey) && !reason)
                data[valueKey + '_FIRM'] = null;
        }

        if (!reason) {
            if (isFilter) delete data[valueKey];
            else {
                data[valueKey] = null;
                if (['agent-all', 'borrower'].includes(optionsType))
                    data[typeKey] = null;
            }
        } else {
            if (dropdownType === 'single') {
                data[valueKey] = optionKey ? reason[optionKey] : reason;
                if (['agent-all', 'borrower'].includes(optionsType))
                    data[typeKey] = reason.groupedBy;
            } else {
                let result = '';

                if (alphabetic) reason = sortArray(reason, (optionKey ? 'name' : null));

                reason.forEach((el, index) => {
                    result += (index !== 0 ? ',' : '') + (optionKey ? el[optionKey] : el);
                });

                if (alphabetic) data[valueKey] = result.slice(0, -1);
                else data[valueKey] = result;
            }
        }

        handleParentChange(data, optionsType, (reason ? reason[optionKey] : ''), valueKey, typeKey, reason, previosData);
    };

    const handleChange = (key, value) => {
        handleInputParentChange(key, value);
    };

    const filterOptions = (options, state) => {
        const filteredRecords = options.filter(function (record) {
            return (
                record &&
                (
                    (record.first_name && record.first_name.trim() !== '') ||
                    (record.last_name && record.last_name.trim() !== '')
                )
            );
        });
        const results = defaultFilterOptions(filteredRecords, state);
        if (optionsType === 'firm')
            options.forEach((option, index) => {
                if (!Object.keys(option).length)
                    options.splice(index, 1);
            });

        if (['agent', 'buyer', 'seller', 'firm', 'lender', 'agent-all', 'borrower'].includes(optionsType) && !results.length && withAddNew)
            return [
                <div className='no-options-container' onClick={(e) => e.stopPropagation()}>
                    No results found
                    <div className='add-new'
                        onClick={(e) => {
                            if (optionsType === 'firm' && hasDrawer) addNewItem();
                            else if (optionsType === 'borrower') addNewItem(valueKey);
                            else addNewItem(valueKey, 'buyer', index);
                              setSearchInput('');
                            const popper = document.getElementsByClassName('MuiAutocomplete-popper');
                            if (popper && popper[0]) popper[0].style.display = 'none';

                            e.stopPropagation();
                        }}>Add new {optionsType === 'agent-all' ? 'agent' :
                            optionsType === 'borrower' ? 'buyer' : optionsType === 'seller' || 'buyer' ? "investor" : optionsType}
                    </div>
                    {
                        optionsType === 'borrower' &&
                        <div className='add-new'
                            onClick={(e) => {
                                addNewItem(valueKey, 'seller', index);

                                const popper = document.getElementsByClassName('MuiAutocomplete-popper');
                                if (popper && popper[0]) popper[0].style.display = 'none';

                                e.stopPropagation();
                            }}>
                            Add new Investor
                        </div>
                    }
                </div>
            ];

        if (!results.length && !inputMode)
            return [
                <div className='no-options-container'
                    onClick={(e) => e.stopPropagation()}>
                    No results found
                </div>
            ];
        return results;
    };

    let values = getValuesForDropdown(value, optionList, optionKey, dropdownType);
    const getFormattedValues = () => {
        if (value && Array.isArray(values))
            // return values.map(el => getOptionLabel(el) + fillText ? fillText:'').join(', ');
            return values
                .map(el => getOptionLabel(el))
                .filter(label => label)         // Ensure non-empty labels are included
                .join(', ') + (fillText ? fillText : '');
        if (value && !inputMode)
            return `${getOptionLabel(values)}${fillText ? fillText : ''}`;
        if (value && inputMode) {
            return value == 'Interest Only' ? value : `${value}${fillText ? fillText : ''}`;
        }
        return '-';
    };

    const rest = {};
    if (groupBy)
        rest.groupBy = (option) => {
            return option.groupedBy;
        };
    console.log('input:', searchInput);
    return (
        <div className={`dropdown-container${viewMode ? ' view-mode' : ''} ${className}`}>
            {
                viewMode && tooltip &&
                <span className={`tooltip-new ${tooltipPosition ? tooltipPosition : ''}`}>{tooltip}</span>
            }
            {
                !viewMode &&
                <Autocomplete className={theme + (dropdownType === 'multiple' ? ' multiple' : '')}
                    multiple={dropdownType === 'multiple'}
                    disabled={disabled}
                    fullWidth
                    getOptionLabel={(option) => getOptionLabel(option)}
                    options={optionList}
                    getOptionDisabled={(option) => firmName != null && (option.NAME === firmName || option.NAME === "  – " + firmName)}
                    value={values}
                    openOnFocus={openOnFocus}
                    id={id}
                    onFocus={handleInputFocus}
                    inputValue={searchInput}
                    onInputChange={(event, inputValue, reason) => {
                        if (onSearchInput && reason === 'input') {
                            onSearchInput(inputValue); //  Trigger API call on search
                            setSearchInput(inputValue);
                        }
                        if (reason === 'clear') {
                            setSearchInput('');
                            if (onSearchInput) {
                                onSearchInput(''); //  Triggers reload of 500 records
                            }
                        }
                    }}
                    renderInput={(params) =>
                        <TextField {...params}
                            label={label}
                            required={required}
                            placeholder={placeholder}
                            variant="outlined"
                            onChange={inputMode ? (event) => {
                                values = event.target.value;
                                handleChangeDropdown({ reason: event.target.value, valueKey, dropdownType, optionKey, parentData: data, isFilter })
                            } : (event) => { }}
                        />}
                    renderTags={(tagValue, getTagProps) =>
                        tagValue.map((option, index) =>
                            <Chip key={index}
                                {...getTagProps({ index })}
                                deleteIcon={<div className='chip-remove-icon' dangerouslySetInnerHTML={{ __html: removeCircle }} />}
                                label={getOptionLabel(option)} />
                        )}
                    // onChange={(event, reason) =>{handleChangeDropdown({ reason, valueKey, dropdownType, optionKey, parentData: data, isFilter })}}
                    onChange={(event, selectedOption) => {
                        // Reset searchInput to selected label OR empty string
                        if (selectedOption) {
                            setSearchInput(getOptionLabel(selectedOption)); //  show selected label
                        } else {
                            setSearchInput(''); //  handle clear
                        }

                        handleChangeDropdown({ reason: selectedOption, valueKey, dropdownType, optionKey, parentData: data, isFilter });
                    }}

                    popupIcon={<div className='dropdown-icon arrow' dangerouslySetInnerHTML={{ __html: arrow }} />}
                    closeIcon={<div className='dropdown-icon' dangerouslySetInnerHTML={{ __html: close }} />}
                    filterOptions={(options, state) => filterOptions(options, state)}
                    freeSolo={customValues ? true : false}
                    {...rest}
                />
            }
            {
                viewMode &&
                <div className={`view-mode-container ${viewClassName}`}>
                    {
                        (!['status'].includes(optionsType) || isOffMarket || 'null') &&
                        <label className='view-mode-label'>{label}</label>
                    }
                    <div className={deleted ? "view-mode-deleted" : ""}>
                        {
                            ['status'].includes(optionsType) && !label &&
                            <span className='view-mode-label status'>Status</span>
                        }
                        {getFormattedValues()}
                    </div>
                </div>
            }
            {
                hasAgentPercent &&
                <div className={`agent-percent-container${percentLabel ? ' has-label' : ''}`}>
                    <Input type='text'
                        valueType='agent-percent'
                        name={percentKey}
                        value={data[percentKey] || ''}
                        label={percentLabel}
                        viewMode={viewMode}
                        deleted={deleted}
                        disabled={disabled}
                        decimals={percentDecimals}
                        handleParentChange={handleChange}
                    />
                </div>
            }
        </div>
    )
};

Dropdown.propTypes = {
    id: PropTypes.string,
    dropdownType: PropTypes.oneOf(['single', 'multiple']),
    options: PropTypes.arrayOf(PropTypes.object),
    optionsType: PropTypes.oneOf(['status', 'source', 'states', 'type', 'transaction', 'category', 'lease', 'market', 'buyer-market', 'subcategorySTNL', 'subcategoryMT', 'subcategoryIndustrialSTNLMT', 'singleTenantOffice', 'multiTenantOffice', 'superUsers', 'profiles', 'buyerStatus', 'agent', 'buyer', 'firm', 'seller', 'team', 'tenant', 'lender', 'checkbox', 'status-financing', 'loan', 'agent-all', 'borrower', 'filters', 'team-members', 'sellerStatus', 'loanquotes-amortization', 'estimatedPrice', 'referralType', 'confirmType', 'roles', 'territory', 'territoryMarket', 'productType', 'title-company']).isRequired,
    optionKey: PropTypes.string,
    optionLabelKey: PropTypes.string,
    value: PropTypes.string,
    valueKey: PropTypes.string.isRequired,
    percentKey: PropTypes.string,
    firmName: PropTypes.string,
    label: PropTypes.string,
    percentLabel: PropTypes.string,
    data: PropTypes.object,
    hasAgentPercent: PropTypes.bool,
    handleParentChange: PropTypes.func.isRequired,
    handleInputParentChange: PropTypes.func,
    disabled: PropTypes.bool,
    viewMode: PropTypes.bool,
    addNewItem: PropTypes.func,
    withAddNew: PropTypes.bool,
    isFilter: PropTypes.bool,
    groupBy: PropTypes.bool,
    theme: PropTypes.oneOf(['default', 'white', 'dark', 'tracking', 'no-border']),
    placeholder: PropTypes.string,
    hasDrawer: PropTypes.bool,
    deleted: PropTypes.bool,
    typeKey: PropTypes.string,
    typeValue: PropTypes.string,
    getSelectedOption: PropTypes.func,
    className: PropTypes.string,
    viewClassName: PropTypes.string,
    fillText: PropTypes.string,
    index: PropTypes.number,
    tooltip: PropTypes.string,
    tooltipPosition: PropTypes.oneOf(['up', 'down']),
    handleInputFocus: PropTypes.func,
    openOnFocus: PropTypes.bool
};

export default Dropdown;
